var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-upload"
  }, [_c('div', {
    staticClass: "ee-upload__hot",
    style: (_vm.style),
    attrs: {
      "title": "点击上传"
    },
    on: {
      "click": _vm.handleOpenFile
    }
  }, [(_vm.path) ? _c('img', {
    attrs: {
      "src": _vm.path,
      "alt": ""
    }
  }) : _c('i', {
    class: ("text-icon icon-" + _vm.icon)
  }), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ee-upload__desc"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f547dd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/upload/Upload.vue
// module id = 572
// module chunks = 13